import { Account } from '@/api/generated'
import { Role } from '@/shared/models/role'
import { Injector } from '@/config/dependency-injection'
import { AuthenticationService } from '@/authentication/authentication-service'

export function isAdmin(account: Account) {
  return hasRole(account, Role.ADMIN)
}

export function isUser(account: Account) {
  return hasRole(account, Role.USER)
}

export function hasRole(account: Account, ...roles: Role[]): boolean {
  return account.roles.some(accountRole => roles.find(role => role === accountRole) !== undefined)
}

export function activeUser() {
  return Injector.get(AuthenticationService).authenticatedUser()
}

export function activeUserIsAdmin() {
  let isPremium = false

  const activeUser = Injector.get(AuthenticationService).authenticatedUser()

  if (activeUser !== undefined) {
    isPremium = activeUser.roles.indexOf('ADMIN') > -1
  }

  return isPremium
}

export function activeUserIsOwner(organisationId: number) {
  let isOwner = false

  const activeUser = Injector.get(AuthenticationService).authenticatedUser()

  if (activeUser !== undefined) {
    isOwner = activeUser.organisation.id === organisationId
  }

  return isOwner
}

export function activeUserIsPremium() {
  let isPremium = false

  const activeUser = Injector.get(AuthenticationService).authenticatedUser()

  if (activeUser !== undefined) {
    isPremium = activeUser.roles.indexOf('PREMIUM') > -1
  }

  return isPremium
}

export function userIsAuthenticated(): boolean {
  return isUser(activeUser())
}
